var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "loop_x5F_alt1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M26,16l-6,6h4c0,1.102-0.898,2-2,2H10c-1.102,0-2-0.898-2-2v-2H4v2c0,3.309,2.691,6,6,6h12 c3.309,0,6-2.691,6-6h4L26,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M22,4H10c-3.309,0-6,2.691-6,6v0.062H0L6,16l6-5.938H8V10c0-1.102,0.898-2,2-2h12 c1.102,0,2,0.898,2,2v2h4v-2C28,6.691,25.309,4,22,4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateArrowIcon);
export default __webpack_public_path__ + "static/media/updateArrowIcon.0110875ec158e9385f99de482488f64e.svg";
export { ForwardRef as ReactComponent };